import React, { useEffect, useState } from 'react';
import ReusableTable from "../ReusableTable/ReusableTable";
import classes from './AccreditationA.module.css';
import axios from 'axios';
import { env } from '../../constants/env';
import { useAuth } from '../../context/AuthContext';

const AccreditationA = () => {
  const { token } = useAuth();
  const [labData, setLabData] = useState([]);
  const [loading, setLoading] = useState(true);

  const sectionColumns = [
    { label: 'Date & time entered', field: 'date' },
    { label: 'Laboratory name', field: 'laboratoryName' },
    { label: 'HPCZ License number', field: 'licenseNumber' },
    { label: 'Physical address', field: 'address' },
    { label: 'Facility phone', field: 'phone' },
    { label: 'Facility Email', field: 'email' },
  ];

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
        headers: { Authorization: `Bearer ${token}` }});
        const formatted = res.data.map(lab => ({
          date: new Date(lab.createdAt).toLocaleString(),
          laboratoryName: lab.labName || "",
          licenseNumber: lab.hpczLicense || "",
          address: lab.physicalAddress || "",
          phone: lab.telephone || "",
          email: lab.email || "",
          id: lab._id
        }));
        setLabData(formatted);
      } catch (err) {
        console.error('Error fetching labs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLabs();
  }, []);

  return (
    <div className={classes.wrapper}>
      <ReusableTable
        title="SADCAS - F134  [A]"
        columns={sectionColumns}
        data={loading ? [] : labData}
        detailsLink="lab-details"
        accreditationName="SADCAS F134-A"
      />
    </div>
  );
};

export default AccreditationA;